import { Controller } from "@hotwired/stimulus"

const REQUEST_BUTTON_EVENT_NAME = "service_request_button_click"
const SUBMIT_BUTTON_EVENT_NAME = "service_request_submit_click"
const REFERRAL_COOKIE_NAME = "ga4_referral"

type GtagFn = (command: "event", eventName: string, params: Record<string, unknown>) => void

// Connects to data-controller="ga4-service-request"
// 「依頼画面へ」「依頼する」ボタン押下時に GA4 イベントを送信する
// referral Cookie があればイベントに付与し、流入経路（step_75 等）を識別できるようにする
export default class extends Controller {
  static values = {
    serviceId: Number,
    clientId: Number
  }

  declare readonly serviceIdValue: number
  declare readonly clientIdValue: number

  // 「依頼画面へ」ボタン押下時のイベント送信
  track(): void {
    this.#sendEvent(REQUEST_BUTTON_EVENT_NAME)
  }

  // 「依頼する」ボタン押下時のイベント送信
  // 依頼完了後はリベシティ(外部ホスト)へリダイレクトされ完了ページでの計測ができないため、
  // 確認画面の submit ボタン押下時に beacon で送信する
  // referral Cookie の破棄は依頼完了時にサーバ側 (OrdersController#create) で行う
  trackSubmit(): void {
    this.#sendEvent(SUBMIT_BUTTON_EVENT_NAME)
  }

  #sendEvent(eventName: string): void {
    const gtag = (window as unknown as { gtag?: GtagFn }).gtag
    if (typeof gtag !== "function") return
    if (!this.serviceIdValue || !this.clientIdValue) return

    const context = `service_${this.serviceIdValue}_client_${this.clientIdValue}`
    const referral = this.#readReferralCookie()

    gtag("event", eventName, {
      referral: referral ? `${referral}_${context}` : context,
      transport_type: "beacon"
    })
  }

  #readReferralCookie(): string | null {
    const name = `${REFERRAL_COOKIE_NAME}=`
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name))
    return cookie ? decodeURIComponent(cookie.slice(name.length)) : null
  }
}
